export default {
  title: "Help",
  subtitle:
    "Our experts are ready to help you with any problem during the exhibition. Tell us about your problem:",
  exhibition: "Exhibition",
  pavilion: "Pavilion",
  stand: "Stand",
  name: "Name",
  phone: "Phone",
  problemCategory: "Application category",
  infoText: "Text",
  privatePolicy:
    "I hereby consent to the processing of my personal data on the following",
  privatePolicyLink: "conditions for the processing of personal data",
  submit: "Submit",
  submitAgain: "Submit new one",
  subtitleSuccess:
    "Our manager will contact you within 15 minutes to clarify your request.",
  titleSuccess: "The request sent successfully",
  titleExpired: "Thank you for your requests.",
  subTitleExpired: "This service is available only during the exhibition.",
  error: "An error has occurred, please try again later."
};
